import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row", "staticHeader", "embeddedHeader"]

  filter() {
    const filterValue = this.inputTarget.value.toUpperCase()
    const isSearching = filterValue.length > 0

    // Toggle static header (A)
    if (this.hasStaticHeaderTarget) {
      this.staticHeaderTarget.style.display = isSearching ? "none" : ""
    }

    // Toggle embedded headers (B-Z)
    this.embeddedHeaderTargets.forEach(header => {
      header.style.display = isSearching ? "none" : ""
    })
    
    this.rowTargets.forEach(row => {
      const cell = row.getElementsByTagName("td")[0]
      if (cell) {
        const text = cell.textContent || cell.innerText
        if (text.toUpperCase().indexOf(filterValue) > -1) {
          row.style.display = ""
        } else {
          row.style.display = "none"
        }
      }
    })
  }
}
